export default "__VITE_ASSET__197cdb01__"